import { render, staticRenderFns } from "./BlackGoldSlotGames.vue?vue&type=template&id=795cc398&"
import script from "./BlackGoldSlotGames.vue?vue&type=script&lang=js&"
export * from "./BlackGoldSlotGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports